import React from 'react';
import { PropTypes } from 'prop-types';
import { Icon, Button } from '@unite-us/app-components';
export function NoReferralsDisplay(_ref) {
  var hasDraftReferral = _ref.hasDraftReferral,
    navigateToAddResources = _ref.navigateToAddResources,
    onClick = _ref.onClick,
    crtb1239AdaptDraftReferralFlow = _ref.crtb1239AdaptDraftReferralFlow;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid place-content-center mt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    icon: "Referral",
    size: 64,
    color: "dark-border-grey"
  }))), /*#__PURE__*/React.createElement("h1", {
    className: "text-2xl font-black grid place-content-center my-5"
  }, "No Referrals"), /*#__PURE__*/React.createElement("p", null, "Head back to the search page to add programs and send referrals on your client's behalf."), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center mt-3"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "find-programs",
    onClick: crtb1239AdaptDraftReferralFlow && hasDraftReferral ? navigateToAddResources : onClick,
    label: "Find Programs",
    icon: {
      name: "Search",
      color: "action-blue",
      position: "left"
    },
    className: "normal-case text-black bg-light-pale-blue border border-current-blue rounded mt-5 hover:bg-gray-100"
  }))));
}
;
NoReferralsDisplay.propTypes = {
  navigateToAddResources: PropTypes.func,
  onClick: PropTypes.func.isRequired
};
export default NoReferralsDisplay;
//# sourceMappingURL=NoReferralsDisplay.js.map